// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__9r3xV","spacer":"styles_spacer__E1aqT","blink":"styles_blink__d8M3e"};